export const zsActivityTerms = {
  history: {
    title: `Expecting Zs but can't see them?`,
    text: `- It can take up to 72 hours for Zs to show up in your balance after you visit
- You may need to [Claim Zs](../claim-zs) for your takeaway order or Zizzi visit
- Still unsure? Our [FAQs](../how-it-works) can help!`,
  },
  expired: {
    title: 'For how long are my Zs valid?',
    text: 'Zs will expire after 12 months. This is calculated from the date you earned the Zs - so make sure you redeem them for tasty Perkz before then!',
  },
};
